
export default {
  name: "spinnerManager",
  props: {
    brand: {
      type: String,
      default: "others",
    },
    path: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      publicPath: process.env.publicPath || null,
    };
  },
  computed: {
    url() {
      const path = this.path || this.publicPath || "/";
      var brands = {
      'nh': 'nh',
      'collection': 'collection',
      'default': 'others'
      };
      const brand = (brands[this.brand] || brands['default']);
      return `${path}spinner/${brand}.gif`;
    },
  },
};
